(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeader = document.querySelector('sticky-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.navOnScrollUp = this.getAttribute('data-sticky-type') === 'nav-on-scroll-up' //header always sticky, Nav bar on scroll up
      this.nav = this.querySelector('.js-nav')
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if(this.navOnScrollUp) document.documentElement.style.setProperty('--header-nav-height', `${this.nav.offsetHeight}px`);

      if (this.headerIsAlwaysSticky || this.navOnScrollUp) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', (event) => {
        this.onScrollHandler(event);
      }, false);

      this.createObserver();

    }

    setStickyHeaderHeight() {
      if (this.stickyHeader) {
        document.documentElement.style.setProperty('--sticky-header-height', `${this.stickyHeader.offsetHeight}px`);
        const announcementBar = document.querySelector('.section-announcement-bar');
        let stickyHeaderHeightWithAnnouncementBar = this.stickyHeader.offsetHeight;
        if(announcementBar) stickyHeaderHeightWithAnnouncementBar = this.stickyHeader.offsetHeight + announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--sticky-header-height-with-announcement-bar', `${stickyHeaderHeightWithAnnouncementBar}px`);
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.setStickyHeaderHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const colorScheme = this.header.querySelector('sticky-header').dataset.colorScheme;
      const stickyColorScheme = this.header.querySelector('sticky-header').dataset.stickyColorScheme;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');


        this.header.querySelector('sticky-header').classList.remove(colorScheme);
        this.header.querySelector('sticky-header').classList.add(stickyColorScheme);
        if(this.navOnScrollUp) this.header.classList.add('shopify-section-header-nav-hidden');
        this.setStickyHeaderHeight();

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.header.querySelector('sticky-header').classList.add(colorScheme);
        this.header.querySelector('sticky-header').classList.remove(stickyColorScheme);
        if(this.navOnScrollUp) this.header.classList.remove('shopify-section-header-nav-hidden');
        this.setStickyHeaderHeight();
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.navOnScrollUp) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

  items.forEach((item) => {
    const summary = item.querySelector("summary");
    item.addEventListener("mouseover", () => {
      if (item.classList.contains("closing")) {
        item.classList.remove("closing");
      }

      item.setAttribute("open", true);
      summary.setAttribute("aria-expanded", "true");
    });

    item.addEventListener("mouseleave", () => {
      item.classList.add("closing");
      summary.setAttribute("aria-expanded", "false");
    });

    item.addEventListener("animationend", (e) => {
      if (e.animationName === "close-megamenu") {
        item.classList.remove("closing");
        item.removeAttribute("open");
      }
    });
  });

  const desktopBrandImages = document.querySelector(".megamenu-logo-images");

  let startX;
  let scrollLeft;
  let isDown;

  desktopBrandImages.addEventListener("mousedown", (e) => mouseIsDown(e));
  desktopBrandImages.addEventListener("mouseup", (e) => mouseUp(e));
  desktopBrandImages.addEventListener("mouseleave", (e) => mouseLeave(e));
  desktopBrandImages.addEventListener("mousemove", (e) => mouseMove(e));

  function mouseIsDown(e) {
    isDown = true;
    startX = e.pageX - desktopBrandImages.offsetLeft;
    scrollLeft = desktopBrandImages.scrollLeft;
  }
  function mouseUp(e) {
    isDown = false;
  }
  function mouseLeave(e) {
    isDown = false;
  }
  function mouseMove(e) {
    if (isDown) {
      e.preventDefault();
      const x = e.pageX - desktopBrandImages.offsetLeft;
      const walkX = (x - startX) * 1;
      desktopBrandImages.scrollLeft = scrollLeft - walkX;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const quickLinkLists = document.querySelectorAll('.collection-quick-link-list').forEach((quickLinkList) => {
    let startX;
    let scrollLeft;
    let isDown;

    quickLinkList.addEventListener('mousedown', (e) => mouseIsDown(e));
    quickLinkList.addEventListener('mouseup', (e) => mouseUp(e));
    quickLinkList.addEventListener('mouseleave', (e) => mouseLeave(e));
    quickLinkList.addEventListener('mousemove', (e) => mouseMove(e));

    function mouseIsDown(e) {
      isDown = true;
      startX = e.pageX - quickLinkList.offsetLeft;
      scrollLeft = quickLinkList.scrollLeft;
    }
    function mouseUp(e) {
      isDown = false;
    }
    function mouseLeave(e) {
      isDown = false;
    }
    function mouseMove(e) {
      if (isDown) {
        e.preventDefault();
        const x = e.pageX - quickLinkList.offsetLeft;
        const walkX = (x - startX) * 1;
        quickLinkList.scrollLeft = scrollLeft - walkX;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quick-brand')) {
    class QuickBrand extends HTMLElement {
      connectedCallback() {
        this.lists = this.querySelectorAll('.collection-quick-link-list');
        if (!this.lists || this.lists.length === 0) return;

        this.classList.remove('ready');
        setTimeout(() => {
          this.lists.forEach((list) => {
            this.updateJustify(list);
            this.enableDragScroll(list);
          });
          this.classList.add('ready');
        }, 100);

        this.resizeHandler = () => {
          this.lists.forEach((list) => this.updateJustify(list));
        };
        window.addEventListener('resize', this.resizeHandler);
      }

      disconnectedCallback() {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      }

      updateJustify(list) {
        if (!list) return;

        const totalWidth = Array.from(list.children).reduce(
          (acc, li) => acc + li.offsetWidth + parseFloat(getComputedStyle(li).marginRight || 0),
          0,
        );
        const containerWidth = list.clientWidth;
        list.style.justifyContent = totalWidth < containerWidth ? 'center' : 'flex-start';
      }

      enableDragScroll(list) {
        if (!list) return;

        const enableDesktopScroll = this.dataset.enableDesktopScroll === 'true';

        const shouldEnableDragScroll = () => {
          if (window.innerWidth < 768) return true;
          return enableDesktopScroll;
        };

        if (!shouldEnableDragScroll()) {
          return;
        }

        let startX = 0;
        let scrollLeft = 0;
        let isDown = false;
        let hasMoved = false;

        list.classList.add('draggable');

        const handleMouseDown = (e) => {
          if (e.button !== 0) return;

          isDown = true;
          hasMoved = false;
          list.classList.add('dragging');

          startX = e.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        };

        const handleMouseMove = (e) => {
          if (!isDown) return;

          e.preventDefault();
          e.stopPropagation();

          const x = e.pageX - list.offsetLeft;
          const walk = (x - startX) * 1.5;

          if (Math.abs(walk) > 3) {
            hasMoved = true;
          }

          list.scrollLeft = scrollLeft - walk;
        };

        const handleMouseUp = (e) => {
          if (!isDown) return;

          isDown = false;
          list.classList.remove('dragging');
        };

        const handleMouseLeave = (e) => {
          if (isDown) {
            isDown = false;
            list.classList.remove('dragging');
          }
        };

        const handleTouchStart = (e) => {
          isDown = true;
          hasMoved = false;

          const touch = e.touches[0];
          startX = touch.pageX - list.offsetLeft;
          scrollLeft = list.scrollLeft;
        };

        const handleTouchMove = (e) => {
          if (!isDown) return;

          const touch = e.touches[0];
          const x = touch.pageX - list.offsetLeft;
          const walk = (x - startX) * 1.5;

          if (Math.abs(walk) > 5) {
            hasMoved = true;
            e.preventDefault();
          }

          list.scrollLeft = scrollLeft - walk;
        };

        const handleTouchEnd = (e) => {
          isDown = false;
        };

        const handleClick = (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            hasMoved = false;
            return false;
          }
        };

        list.removeEventListener('mousedown', list._mouseDownHandler);
        list.removeEventListener('mousemove', list._mouseMoveHandler);
        list.removeEventListener('mouseup', list._mouseUpHandler);
        list.removeEventListener('mouseleave', list._mouseLeaveHandler);
        list.removeEventListener('touchstart', list._touchStartHandler);
        list.removeEventListener('touchmove', list._touchMoveHandler);
        list.removeEventListener('touchend', list._touchEndHandler);
        list.removeEventListener('click', list._clickHandler, true);

        list._mouseDownHandler = handleMouseDown;
        list._mouseMoveHandler = handleMouseMove;
        list._mouseUpHandler = handleMouseUp;
        list._mouseLeaveHandler = handleMouseLeave;
        list._touchStartHandler = handleTouchStart;
        list._touchMoveHandler = handleTouchMove;
        list._touchEndHandler = handleTouchEnd;
        list._clickHandler = handleClick;

        list.addEventListener('mousedown', handleMouseDown, { passive: false });
        list.addEventListener('mousemove', handleMouseMove, { passive: false });
        list.addEventListener('mouseup', handleMouseUp, { passive: true });
        list.addEventListener('mouseleave', handleMouseLeave, { passive: true });

        list.addEventListener('touchstart', handleTouchStart, { passive: true });
        list.addEventListener('touchmove', handleTouchMove, { passive: false });
        list.addEventListener('touchend', handleTouchEnd, { passive: true });

        list.addEventListener('click', handleClick, { capture: true, passive: false });
      }
    }

    customElements.define('quick-brand', QuickBrand);
  }

  } catch(e) { console.error(e); }
})();
})();
